<template>
  <div v-if="showHelpVar && !isUnavailable" @click="helpClick">
    <div class="helpTextBox" :style="'opacity:'+textOpacity+';width:'+helpWidth+'px;'">
      <video v-if="showAI" ref="helpVid" class="voiceGraph" src="../../assets/voice/ai/AI_welcome.mp4" width="500px" ></video>
      <div v-if="showAI && vidEnded" class="voiceBtns">
          <div @click="doHelpBtn('again')" class="voiceBtn">replay help</div>
          <div  v-if="help.type!='event'" @click="doHelpBtn('next')" class="voiceBtn">next topic</div>
      </div>
      <div v-if="showAI" class="AI_Large"><div class="AI_LargeInner"></div></div>
      <div v-if="true" class="helpClose" @click="helpOut">x</div>
      <div v-if="!typeHelp" class="helpText">{{helpText}}</div>
      <audio ref="helpAudio"></audio> 
      <TypeOn v-if="showHelpVar && typeHelp" :speed="typeSpeed" class="helpText"  v-html="helpText"></TypeOn>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import screen from "@/mixins/screen"
import help from "@/mixins/help"
import TypeOn from '@/components/TypeOn'

export default {
  mixins:[ screen,help],
  components: {
   TypeOn
  },
  data() {
    return {
      video:null,
      audio:null,
       showHelpVar:false,
       textOpacity:0,
       vidEnded:false,
       aiPath:"../../assets/voice/ai/"
    };
  },
  mounted(){
   
  },
  computed:{
    fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
				},
    isUnavailable(){
      			return this.$store.getters.getIsUnavailable
  			},
    volume(){
      return this.$store.getters.getVolume
    },
    helpWidth(){
      if(this.showAI){
        return 800
      }
      return 500
    },
    helpInnerMax(){
      return Math.max(this.windowWidth,this.windowHeight)*2
    },
    helpText(){
      if(this.help)
      {
        return this.help.text
      }
    },
    typeSpeed(){
      if(this.help)
      {
        return this.help.writeSpeed || 0.05
      }
      return 0.05
    },
    helpState(){
      if(this.help)
      {
      return this.help.state
      }
    },
     showAI(){
      if(this.help){
        return this.help.showAI=="true"
      }
    },
    typeHelp(){
      if(this.help){
        return this.help.writeOn
      }
    },
    help(){
      return this.$store.getters.getHelp
    }
  },
  methods:{
    showHelpFn(){
     let nextHelp=this.$store.getters.getNextHelp
     console.log("XX Next",nextHelp)
     if(nextHelp){
      nextHelp.shown=true

      if(!this.shownHelps.includes(nextHelp.id)){
        console.log("DO IT")
        nextHelp.force="force"
        this.$store.dispatch("showNextHelp",nextHelp)
        this.playVideo()
        this.$store.dispatch("nextHelp")
      }
      
     }
     
   },
      doHelpBtn(mode){
        if(mode=="again"){
           console.log("AGAIN")
           this.playVideo()
        }else{
          console.log("NEXT HELPXX")
          console.log("PLAY NEXT >>>>",this.help,this.$store.getters.getHelp)
           //this.$store.dispatch("nextHelp")
           
           this.$nextTick(() => {
            this.showHelpFn()
             // console.log("PLAY NEXT >>>>",this.help,this.$store.getters.getHelp)
             // this.playVideo()
           })
          
        }
    
      },
    	playVideo(){
        console.log("PLAY VIDEO")
         if( this.$refs.helpVid){
          this.$refs.helpVid.volume=this.volume
          }
          if(this.$refs.helpAudio){
            this.$refs.helpAudio.volume=this.volume
          }
       
        //let file=require("../../assets/voice/ai/AIDA_welcome.mp4")
        let file
        let loc
        
        if(this.help.file){
          
           loc=this.fireBaseLoc
          if(this.help.file.indexOf("helpCont")>-1){
            file=loc+this.help.file
          }else{
             file=require("../../assets/voice/ai/"+this.help.file)
          }
        
       
        console.log("PLAY VIDEO",this.help)
        //console.log("PLAY VIDEO","../../assets/voice/ai/AIDA_welcome.mp4")
        this.video = document.createElement('video');
        this.video.setAttribute('crossorigin', 'anonymous');
        this.$refs.helpVid.src=file
        this.$refs.helpVid.load()
        this.$refs.helpVid.addEventListener('canplay',this.justPlay)
				//this.$refs.helpVid.addEventListener('ended',this.videoEnded)
				
        }
        if(this.help.audio){
          console.log(this.$refs)
          this.$refs.helpAudio.setAttribute('crossorigin', 'anonymous');
					this.$refs.helpAudio.src=this.fireBaseLoc+this.help.audio
					this.$refs.helpAudio.play()
        }
			},
		justPlay(){
        console.log("CAN PLAY")
         if(this.help.file){
				this.$refs.helpVid.play()
        this.$refs.helpVid.removeEventListener('canplay',this.justPlay)
         }
          
      },
      videoEnded(){
        this.vidEnded=true
        
      },
    helpIn(){
      this.showHelpVar=true
      gsap.to(this,.3,{textOpacity:1,onComplete:this.helpHold})
    },
    helpHold(){
       if(this.help.audio){
          console.log("AUDIO",this.help.audio)
            this.playVideo()
          }
      //gsap.delayedCall(1.5,this.helpOut)
     
    },
    helpClick(){
      if(!this.showAI){
        this.helpOut()
      }
      
    },
    helpOut(){
      gsap.to(this,.3,{textOpacity:0,onComplete:this.helpDone})
    
      
    },
    helpDone(){
       this.showHelpVar=false
       if(this.help && this.help.callBack){
         this.help.callBack()
       }
       this.$store.commit('setHelp',null)
    }
  },
  watch:{
    isUnavailable(val){
      
        this.helpDone()
    
    },
    volume(val){
      
      if( this.$refs.helpVid){
         this.$refs.helpVid.volume=val
      }
    
    },
    helpState(val){

      console.log(" ............   Help WATCH",val)
      if(val=="helpIn"){
        this.helpIn()
        
      }else{
        this.helpOut()
       
      }
    },
    showAI(val){
      if(val){
        let self=this
        this.$nextTick(() => {
          this.vidEnded=false
          if(this.$refs.helpVid){
            this.$refs.helpVid.addEventListener('ended',this.videoEnded)
            
          } 
          this.playVideo()
        })
      }
    }
  }
};
</script>

<style>
  .transission{
    z-index: 3;
    position:absolute;
    left:calc(50% - 1050px);
    top:calc(50% - 1050px);
    width:100px;
    height:100px;
    border-radius:50%;
    border:#000 solid 1000px;
  }
  .helpTextBox{
    z-index: 4;
    font-size:20px;
    width:800px;
    border-radius:10px;
    text-align:left;
    position:absolute;
    left:0px;
    right:0px;
    top:40%;
    color:#fff;
    margin:auto;
    
  }
  .helpText{
    background-color:#000000b4;
    padding:10px;
    width:480px;
    min-height:80px;

  }
  .voiceBtns{
    top:0px;
    width:500px;
    height:200px;
    position: absolute;
    left:0px;
    right:130px;
    margin:auto;
    cursor:pointer;
  }
  .voiceBtn{
   position: relative;
    border: solid;
    border-radius: 5px;
    
    display: inline-block;
    text-align: center;
    width: 150px;
    height: 28px;
    margin: 80px 5px;
    cursor:pointer;
  }
  .voiceBtn:hover{
    opacity:1;
    transform:scale(1.02);
  }
  .voiceGraph{
    background-color:#000;
    margin-bottom: -5px;
    position: relative;
    opacity:0.7;
  }
  .AI_Large{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 300px;
    min-height: 300px;
    height: 100%;
    background-color: #000000;
   
   
    opacity:0.7
  }
  .AI_LargeInner{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 280px;
     height: 280px;
    background-image: url(/img/AI.87a28f9f.png);
    background-size: 280px 280px;
    background-repeat: no-repeat;
    background-position: 0px 0px;
    border-radius: 50%;
    box-shadow: inset #43c2ff 0px 0px 20px 10px;
   
  }
  .helpClose{
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
  }
  .helpClose:hover{
    background-color: #3e3e3e;
  }
</style>